import OCTContextBase from "./octContextBase";
import { octThicknessGradient, octColorSettings, generatePalette } from "../canvas/canvasUtils";
import store from "../store";

export default class RasterComparisonViewContext extends OCTContextBase {
  constructor(group, exam, view, imgKey) {
    super(group, exam, "rasterComparisonView", null, imgKey);

    this.view = view;

    this.loadComposite = false;
    this.loadHD = false;
    
    this.octColorSettings = octColorSettings();
    this.slicePalette = octThicknessGradient;
  }

  startupTask() {
    return store.dispatch("getOCTInfo", { exSrNo: this.exSrNo, groupName: this.groupName })
      .then(data => this.setOCTInfo(data.data))
      .then(this.refreshImages);
  }

  refreshImages() {
    return store.dispatch("loadOCTImagesForMultiview");
  }

  toggleInverted() {
    this.octColorSettings.isInverted = !this.octColorSettings.isInverted;
    if (this.octColorSettings.isInverted) this.octColorSettings.colorPalette = null;
  }
  toggleColorPalette() {
    this.octColorSettings.isInverted = false;
    if (this.octColorSettings.colorPalette) this.octColorSettings.colorPalette = null;
    else this.octColorSettings.colorPalette = this.getSlicePalette();
  }
  getSlicePalette() {
    return generatePalette(this.slicePalette);
  }
}